import React, { ReactNode } from 'react'
import { SxProps } from '@mui/material/styles'
import { PrimaryStyledButton, SecondaryStyledButton } from './styles'

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: ReactNode
  width?: string
  sx?: SxProps
}

export const PrimaryButton = (props: ButtonProps) => (
  <PrimaryStyledButton {...props}/>
)

export const SecondaryButton = (props: ButtonProps) => (
  <SecondaryStyledButton {...props}/>
)
